import { render, staticRenderFns } from "./import-pt.vue?vue&type=template&id=6618c86e&"
import script from "./import-pt.vue?vue&type=script&lang=js&"
export * from "./import-pt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports